import { Typography } from '@mui/material';
import Paper from 'components/system/Paper';
import { ContentLoading } from 'components/system/Loading';
import usePaymentsStore from 'store/paymentStore';
import usePaymentMethod from 'hooks/usePaymentMethod';
import colors from 'styles/colors';
import PaymentMethodCard from './PaymentMethodCard';
import PaymentMethodEmptyCard from './PaymentMethodEmptyCard';

const PaymentMethod = () => {
  usePaymentMethod();

  const { card, isLoading } = usePaymentsStore((state) => state.paymentMethod);

  let content;

  if (isLoading) {
    content = <ContentLoading />;
  } else if (card) {
    content = <PaymentMethodCard {...card} />;
  } else {
    content = (
      <PaymentMethodEmptyCard />
    );
  }

  return (
    <Paper sx={{ height: '142px', overflowX: 'auto', overflowY: 'hidden' }}>
      <Typography variant="h6" sx={{ color: colors.text.primary }}>
        Payment Method
      </Typography>
      {content}
    </Paper>
  );
};

export default PaymentMethod;
